import {connect} from 'react-redux';
import 'components/ReportAlert/ReportAlert.scss';
import ReportAlert from 'components/ReportAlert/ReportAlert.lazy';
import {updateReportAlert} from 'ducks/alerts';

const mapStateToProps = (state, ownProps) => {
  const {isShown, level, msg, variant} = state.alerts;
  return {
    ...ownProps,
    isShown,
    level,
    msg,
    variant,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClose: () => dispatch(updateReportAlert({isShown: false}))
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
  };
};

const ReportAlertContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(ReportAlert);

export { ReportAlertContainer, ReportAlert };
export default ReportAlertContainer;